import script from "./HTSnakeGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTSnakeGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTSnakeGamePlay.vue?vue&type=style&index=0&id=471df1ba&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471df1ba"]])

export default __exports__